<template>
  <!-- viewBox: "0 0 120 120", width: "120", height: "120" -->
  <g class="progress-circle">
    <defs>
      <linearGradient id="PSgrad_0" x1="100%" x2="0%" y1="0%" y2="0%">
        <stop offset="0%" stop-color="rgb(75,115,235)" stop-opacity="1" />
        <stop offset="100%" stop-color="rgb(55,212,107)" stop-opacity="1" />
      </linearGradient>
    </defs>
    <!-- 需要显示的圆环 通过修改 stroke-dasharray="0 1069"的 0 值那块，(角度/360) = 圆弧长度/周长  这里的圆弧长度就是第一个值-->
    <circle class="cls-4" cx="60" cy="60" r="50" stroke="#e3e5eb" />
    <circle
      class="cls-4 cls-41"
      cx="60"
      cy="60"
      r="50"
      :stroke-dasharray="dasharray"
      stroke="url(#PSgrad_0)"
      stroke-linecap="round"
      sweep-flag="1"
    />
    <text class="cls-5" x="60" y="58">
      {{ numName }}
    </text>
    <text class="cls-5" x="65" y="78">
    <!-- <text class="cls-5" x="65" y="68"> -->
      {{ percent }}
    </text>
  </g>
</template>

<script>
export default {
  props: {
    num: {
      type: [Number, String],
      default: 0,
      validator: function(val) {
        return !isNaN(val);
      }
    },
    numName: {
      type: [Number, String],
      default: '',
    }
  },
  computed: {
    dasharray() {
      var n = this.num <= 1 ? this.num : this.num / 100;
      return n * 2 * Math.PI * 50 + " " + 2 * Math.PI * 50;
    },
    percent() {
      var n = this.num <= 1 ? this.num : this.num / 100;
      return parseFloat(Number(n * 100).toFixed(2)) + "%";
    }
  }
};
</script>

<style lang="scss" scoped>
// e3e5eb
.cls-4 {
  fill: none;
  stroke-width: 10px;
  transform: rotate(-90deg);
  transform-origin: center;
}

.cls-5 {
  font-size: 20px;
  font-family: "Noto Sans S Chinese";
  text-anchor: middle; /* 文本水平居中 */
  // fill: #4b73eb;
  fill: #4c88ff;
}
</style>
